import validate from "/app/node_modules/.pnpm/nuxt@3.10.3_@parcel+watcher@2.4.1_@types+node@20.12.7_encoding@0.1.13_eslint@8.57.0_ior_7948679a5bcd5734c2d946ee87388870/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirection_45global from "/app/apps/online-store/middleware/redirection.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.10.3_@parcel+watcher@2.4.1_@types+node@20.12.7_encoding@0.1.13_eslint@8.57.0_ior_7948679a5bcd5734c2d946ee87388870/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirection_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "search-guard": () => import("/app/apps/online-store/middleware/search-guard.ts")
}